<script>
  import { Router, Link, Route, navigate } from "svelte-routing";
  import Cookies from 'js-cookie';
  import { v4 as uuidv4 } from 'uuid';

  import NavTop from 'src/components/nav/navTop.svelte';
  import Dashboard from 'src/components/dashboard/dashboard.svelte';
  import Home from 'src/components/home/home.svelte';

  import Room from 'src/models/Room';

  import roomStore from 'src/stores/Room';
  import cookieStore from 'src/stores/Cookie';

  let token = Cookies.get('token');
  $: token = Cookies.get('token');

  if (!token) {
    token = uuidv4();
    Cookies.set('token', token);
  }

  const conn = new WebSocket('ws://simple-pointing-poker.com:8080');
  let isClosed = false;

  conn.onopen = function(e) {
    console.log(`register: ${token}`);
    conn.send(JSON.stringify({
      action: 'register',
      token: token
    }));
  };

  conn.onclose = () => {
    console.log(`close connection`);
    navigate(`/`, { replace: true });
    isClosed = true;
  }

  conn.onmessage = function(e) {
    const response = JSON.parse(e.data);
    console.log(response);
    let room = new Room();
    if (response.room) {
      room = new Room(response.room);
      room.me = room.members.find(m => m.id == token);
    }
    roomStore.update(s => {
      return room;
    });

    switch(response.action) {
      case 'create-response':
      case 'join-response':
        navigate(`/room`, { replace: true });
      break;
      case 'room-update':
        // Do nothing
      break;
      case 'leave-response':
      case 'close-response':
        navigate(`/`, { replace: true });
      break;
      default:
        console.error(`Unknown response ${e.data}`);
    }
  };



  export let url = "";
</script>

<Router url="{url}">
    {#if $roomStore.id && !isClosed  && conn}
      <NavTop conn={conn} token={token}/>

      <Route path="" component={Dashboard} conn={conn}></Route>
      <Route path="/room" component={Dashboard} conn={conn}></Route>
    {:else if conn && !isClosed}
      <Route path="" component={Home} conn={conn}></Route>
      <Route path="/home" component={Home} conn={conn} />
    {:else if conn && isClosed}
      <div id="layoutAuthentication">
        <div id="layoutAuthentication_content">
          <main>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-5">
                  <div class="card shadow-lg border-0 rounded-lg mt-5">
                    <div class="card-header">
                      <h3 class="text-center font-weight-light my-4">
                        Error
                      </h3>
                    </div>
                    <div class="card-body">
                      Connection is closed. Reload the page to open a new connection.
                    </div>
                    <div class="card-footer text-center py-3">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    {/if}
</Router>
